import { Injectable } from '@angular/core';
import { AbilityBuilder, Ability, PureAbility } from '@casl/ability';
import { Store } from '@ngrx/store';
import { KeycloakEvent, KeycloakEventType, KeycloakService } from 'keycloak-angular';
import { KeycloakProfile, KeycloakTokenParsed } from "keycloak-js";
import { Observable, from } from 'rxjs';
import { updateLoggedInUser } from 'src/app/core/store/UserInfo.action';
import { StoreDropdowns, UserInformation } from 'src/app/shared/models/app-models';
import { AppAbility } from 'src/app/core/services/permissions/AppAbility';
import { KeycloakUser } from 'src/app/shared/models/database-models';
import { MP_ROLE_PREFIX } from 'src/app/data/constants/Data';
import { isEqual } from 'lodash';

@Injectable()
export class AuthService {
    user!: KeycloakUser
    constructor(private keycloakService: KeycloakService, private store: Store<{ user: UserInformation }>, private ability: PureAbility) {
        keycloakService.keycloakEvents$.subscribe(async (event: KeycloakEvent) => {
            try {
                if (event.type == KeycloakEventType.OnAuthRefreshSuccess) {
                    let test = await this.keycloakService.loadUserProfile()
                    console.log(test);
                    let user: UserInformation = {
                        userName: this.keycloakService.getUsername(),
                        token: await this.keycloakService.getToken(),
                        fullName: (await this.keycloakService.loadUserProfile()).lastName ?? '',
                        roles: this.keycloakService.getUserRoles().filter(x => x.startsWith(MP_ROLE_PREFIX))

                    }
                    this.store.dispatch(updateLoggedInUser({ user: user }))
                }

            } catch (e) {
                // do nth
                console.log("Authentication Failed.")
            }

        })
    }

    public getLoggedUser(): KeycloakTokenParsed | undefined {
        try {
            const userDetails: KeycloakTokenParsed | undefined = this.keycloakService.getKeycloakInstance().idTokenParsed;
            console.log(userDetails);
            return userDetails;
        } catch (e) {
            console.error("Exception", e);
            return undefined;
        }
    }

    public async isLoggedIn(): Promise<boolean> {
        return await this.keycloakService.isLoggedIn();
    }

    public async loadUserProfile(): Promise<KeycloakProfile> {
        return await this.keycloakService.loadUserProfile();
    }

    public login(): void {
        this.keycloakService.login();
    }

    public logout(): void {
        this.keycloakService.logout(window.location.origin);
    }

    public redirectToProfile(): void {
        this.keycloakService.getKeycloakInstance().accountManagement();
    }

    public getRoles(): string[] {
        return this.keycloakService.getUserRoles();
    }

    public getUserSessionId(): Observable<string> {
        return from(this.keycloakService.getToken());
    }
}
